"use strict";
"use client";
import { chakra } from '../../styled-system/factory.js';

const Span = chakra("span");

export { Span };
